import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=88edbee6&scoped=true"
import script from "./SavedSearches.vue?vue&type=script&lang=js"
export * from "./SavedSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88edbee6",
  null
  
)

export default component.exports